"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Inbox/NotificationPreferenceModal/Form/MentionSection.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);


var _Form = require('web/components/Form');

const LEVELS = [
  { value: 'all', label: 'All messages' },
  { value: 'mentions', label: 'Mentions only' },
  { value: 'nothing', label: 'Nothing' },
]








const LevelButton




 = ({ value, label, isSelected, onSelect }) => {
  const onClick = _react.useCallback.call(void 0, () => onSelect(value), [onSelect, value])
  return (
    _react2.default.createElement(_Form.Button, { isSecondary: !isSelected, onClick: onClick, ariaLabel: `${label}${isSelected ? ', selected' : ''}`, __self: this, __source: {fileName: _jsxFileName, lineNumber: 27}}
      , label
    )
  )
}

const MentionSection = ({ level, onChange, globalMuteNote }) => (
  _react2.default.createElement('div', { className: "chat--notification-settings--section", __self: this, __source: {fileName: _jsxFileName, lineNumber: 34}}
    , _react2.default.createElement('div', { className: "chat--notification-settings--title", __self: this, __source: {fileName: _jsxFileName, lineNumber: 35}}, "Mention alerts" )
    , _react2.default.createElement('div', { className: "chat--notification-settings--subtitle", __self: this, __source: {fileName: _jsxFileName, lineNumber: 36}}, "What notifies you here. Muting still lets mentions of you through; Nothing turns off everything."

    )
    , _react2.default.createElement('div', { className: "chat--notification-settings--mention-levels", role: "group", 'aria-label': "Mention alerts" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 39}}
      , LEVELS.map(option => (
        _react2.default.createElement(LevelButton, {
          key: option.value,
          value: option.value,
          label: option.label,
          isSelected: level === option.value,
          onSelect: onChange, __self: this, __source: {fileName: _jsxFileName, lineNumber: 41}}
        )
      ))
    )
    , globalMuteNote && (
      _react2.default.createElement('div', { className: "chat--notification-settings--subtitle chat--notification-settings--mention-note" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 51}}, globalMuteNote)
    )
  )
)

exports. default = MentionSection
